export enum PUSHER_CHANNELS {
  OFFICE = 'office',
  BETTING = 'betting',
  ALL_USERS = 'all-users',
  CASINO = 'casino',
  SPORTS = 'sports',
  LDB = 'ldb',
}
